import { useState } from 'react';
import { fmtMoeda } from '@/lib/utils/formatters';
import type { SegregacaoNgr } from '@/services/SimplesNacional/Segregacao/api/types';

const PAGE_SIZE = 5;

interface NgrTableProps {
  data: SegregacaoNgr[];
}

export function NgrTable({ data }: NgrTableProps) {
  const [limite, setLimite] = useState(PAGE_SIZE);

  if (data.length === 0) {
    return (
      <p className="px-4 py-6 text-sm text-muted-foreground text-center">
        Nenhum item não gerador de receita neste período.
      </p>
    );
  }

  const visiveis = data.slice(0, limite);
  const restantes = data.length - limite;

  return (
    <div>
      <div className="overflow-x-auto">
        <table className="w-full text-xs">
          <thead>
            <tr className="border-b bg-muted/40">
              <th className="text-left px-4 py-2.5 font-medium text-muted-foreground">Produto</th>
              <th className="text-left px-4 py-2.5 font-medium text-muted-foreground">NCM</th>
              <th className="text-left px-4 py-2.5 font-medium text-muted-foreground">Descrição</th>
              <th className="text-left px-4 py-2.5 font-medium text-muted-foreground">CFOP</th>
              <th className="text-right px-4 py-2.5 font-medium text-muted-foreground">
                Valor Total
              </th>
            </tr>
          </thead>
          <tbody>
            {visiveis.map((row, i) => (
              <tr key={i} className="border-b last:border-0 hover:bg-muted/20 transition-colors">
                <td className="px-4 py-2.5 font-medium">{row.Produto || '—'}</td>
                <td className="px-4 py-2.5 text-muted-foreground">{row.NCM || '—'}</td>
                <td className="px-4 py-2.5 max-w-60 truncate" title={row.Descricao}>
                  {row.Descricao || '—'}
                </td>
                <td className="px-4 py-2.5 text-muted-foreground">{row.CFOP || '—'}</td>
                <td className="px-4 py-2.5 text-right tabular-nums">{fmtMoeda(row.ValTot)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="px-4 py-2.5 flex items-center justify-between text-xs text-muted-foreground border-t">
        <span>
          {visiveis.length} de {data.length} item(s)
        </span>
        {restantes > 0 && (
          <button
            onClick={() => setLimite(l => l + PAGE_SIZE)}
            className="text-primary hover:underline font-medium"
          >
            Ver mais ({restantes} restante{restantes !== 1 ? 's' : ''})
          </button>
        )}
      </div>
    </div>
  );
}
